const {fontFamily} = require("tailwindcss/defaultTheme");
/** @type {import('./ExtendedTailwindConfig.interface').ExtendedTailwindConfig} */

module.exports = {
	content: [
		"./pages/**/*.{js,ts,jsx,tsx}",
		"./components/**/*.{js,ts,jsx,tsx}"
	],
	safelist: ["lg:grid-cols-4"],
	theme: {
		extend: {
			screens: {
				"w1440": "1441px",
				"2xl-small": "1536px",
				"2xl": "1776px"
			},
			colors: {
				"leo-light-gray": "#F1F1F1",
				"leo-very-light-gray": "#CCCCCC",
				"leo-orange": "#ff7e00",
				"leo-button-gray": "#3C3C3B",
				"leo-divider-gray": "rgba(90, 90, 90)",
				"leo-transparency": "rgba(0, 0, 0, 0)",
				"leo-text-gray": "#CCCCCC",
				"leo-divider-gray-2": "#CBCBCB",
				"leo-disabled-gray": "#B4B4B4",
				"leo-placeholder-gray": "#6b7286",
				"leo-footer-bottom-gray": "#464545",
				"leo-text-gray": "#A4A4A4",
				"leo-main-filter-gray": "#F9F9F9",
				"leo-blue": "#43c4f7",
				"leo-brown": "#857a68",
				"leo-dark-brown": "#5C4033"
			},
			fontFamily: {
				sans: ["var(--font-source-sans-pro)", ...fontFamily.sans],
				"libre-baskerville": [
					"var(--font-libre-baskerville)",
					...fontFamily.serif
				],
				noto: ['NotoSans', 'sans-serif'],
				lato: ['Lato']
			},
			fontSize: {
				"5xl": "3.45rem",
				"6xl": "4.05rem"
			}
		}
	},
	plugins: [
		// require("tailwindcss-debug-screens"),
		require("@tailwindcss/forms"),
		function ({addVariant}) {
			addVariant("scrollbar", "&::-webkit-scrollbar");
			addVariant("scrollbar-track", "&::-webkit-scrollbar-track");
			addVariant("scrollbar-thumb", "&::-webkit-scrollbar-thumb");
		}
	]
};
